import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';

export default function GlobalDbnTaxonomySubDomainAttributeBasicInfoComponent({
  subDomains,
  item,
  libraryData,
  handleFormItemChange,
  selectedDomain,
  parentDomain,
  setData,
  index,
  newRow,
  isRowEmpty,
  // removeItem,
  // isLastRow
}: any) {
  // console.log('GlobalDbnTaxonomySubDomainAttributeBasicInfoComponent item', item)
  return (
    <>
      <td className="px-2 py-4 whitespace-nowrap">
        <InputContainer
          // label="Name"
          isDisabled={true}
          name="Name"
          onValueChange={(event: any) => {
            handleFormItemChange(setData, index, "Name", event.target.value, newRow, isRowEmpty)
          }}
          type="text"
          value={item?.Name}
        />
      </td>
      
      <td className="px-2 py-4 whitespace-nowrap">
        
        <InputContainer
          // label="Name"
          isDisabled={true}
          name="SubDomainName"
          onValueChange={(event: any) => {
            handleFormItemChange(setData, index, "SubDomainName", event.target.value, newRow, isRowEmpty)
          }}
          type="text"
          value={item?.SubDomainName}
        />
      </td>

      <td className="px-2 py-4 whitespace-nowrap">
        <InputContainer
          // label="SourceName"
          name="SourceAttributeName"
          // isDisabled={true}
          onValueChange={(event: any) => {
            handleFormItemChange(setData, index, "AttributeValueSource.SourceAttributeName", event.target.value, newRow, isRowEmpty)
          }}
          type="text"
          value={item?.AttributeValueSource?.SourceAttributeName}
        />
      </td>

      <td className="px-2 py-4 whitespace-nowrap">
        <InputContainer
          // label="Control Type"
          labelField="Text"
          list={libraryData?.result?.AttributeControlType}
          onValueChange={(event: any, newValue: any) => {
            handleFormItemChange(setData, index, "AttributeValueSource.ControlType", event.target.value, newRow, isRowEmpty)
          }}
          optionName="Choose Control Type"
          type="select"
          value={item?.AttributeValueSource?.ControlTypeId}
          valueField="Value"
        />
          
      </td>
      
      <td className="px-2 py-4 whitespace-nowrap">
        <InputContainer
          // label="Control Type"
          labelField="Text"
          list={libraryData?.result?.SourceType}
          onValueChange={(event: any, newValue: any) => {
            handleFormItemChange(setData, index, "AttributeValueSource.SourceType", event.target.value, newRow, isRowEmpty)
          }}
          optionName="Choose Source Type"
          type="select"
          value={item?.AttributeValueSource?.SourceTypeId}
          valueField="Value"
        />         
      </td>

      <td className="px-2 py-4 whitespace-nowrap">
        <InputContainer
          // label="SourceName"
          name="SourceTypeName"
          // isDisabled={true}
          onValueChange={(event: any) => {
            handleFormItemChange(setData, index, "AttributeValueSource.SourceTypeName", event.target.value, newRow, isRowEmpty)
          }}
          type="text"
          value={item?.AttributeValueSource?.SourceTypeName}
        />
      </td>
      <td className="px-2 py-4 whitespace-nowrap">
        <InputContainer
          name="IsAppliedForVariant"
          isDisabled={true}
          onValueChange={(event: any) => {
            handleFormItemChange(setData, index, "AttributeValueSource.IsAppliedForVariant", event, newRow, isRowEmpty)

          }}
          type="checkbox"
          value={item?.AttributeValueSource?.IsAppliedForVariant}
        />
      </td>
      {/* <td className="px-2 py-4 whitespace-nowrap">
        {!isLastRow && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none"
        className='cursor-pointer'
        onClick={removeItem(index)}
        >
          <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M9.5 16.5L9.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M14.5 16.5L14.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>}
      </td> */}
    </>
  )
}